import { InjectionToken } from '@angular/core';

export let APP_SETTINGS = new InjectionToken('app-settings');

export interface IAppSettings {
    apiEndpoint: string;
}

export const AppSettings: IAppSettings = {
    apiEndpoint: '/api/'
};
